// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FeaturesV3 = require("./FeaturesV3.bs.js");

var useFeatureFlipper = FeaturesV3.useFeatureFlipper;

var jsProvider = FeaturesV3.JsProvider.make;

exports.useFeatureFlipper = useFeatureFlipper;
exports.jsProvider = jsProvider;
/* FeaturesV3 Not a pure module */
